// core/services/invitesService.ts — 1.24.00 personal invite links (B2).
//
// Three thin wrappers, no store:
//   lookup(code)  → GET  /invites/<code>/            (AllowAny; 404 not_found when unknown/revoked)
//   mine()        → GET  /users/me/invite/           (the member's one active code — created
//                                                     server-side in the User post_save signal,
//                                                     so this is a plain read, never a create)
//   regenerate()  → POST /users/me/invite/regenerate/ (old code revoked in the same transaction)
//
// Components must NOT import this directly — use hooks/useInviteLink.ts /
// hooks/useInviteInfo.ts.

import type { InviteInfo, InviteLink } from '@/core/models/account';
import { api } from '@/core/lib/apiClient';

export const invitesService = {
  /** Who owns a public invite link. Throws ApiError('not_found', 404) for an unknown or revoked code. */
  async lookup(code: string): Promise<InviteInfo> {
    return api<InviteInfo>(`/invites/${encodeURIComponent(code)}/`);
  },

  /** The signed-in member's active invite link. */
  async mine(): Promise<InviteLink> {
    return api<InviteLink>('/users/me/invite/');
  },

  /** Retire the current code and mint a new one. Returns the new link. */
  async regenerate(): Promise<InviteLink> {
    return api<InviteLink>('/users/me/invite/regenerate/', { method: 'POST', body: {} });
  },
} as const;
